module.exports = __webpack_public_path__ + "img/testoutBg.1c3fc348.png";